import {
    Box, Flex,
    Heading,
    Text,
    useDisclosure,
    VStack
} from "@chakra-ui/react";
import {PaginationRow, StyledButton} from "../../../components";
import {useState} from "react";
import {ReactComponent as Delete} from "../../../assets/icons/profile/delete_icon.svg";
import {ReactComponent as Edit} from "../../../assets/icons/profile/edit.svg";
import {NotifTemplates} from "../../../helpers/data-jsons";

const Notifications = ({setActiveTab}) => {
    const [currentPage, setCurrentPage] = useState(0);
    const [itemsPerPage, setItemsPerPage] = useState(5);

    const totalPages = Math.ceil(NotifTemplates.length / itemsPerPage);
    const currentItems = NotifTemplates.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);

    return (
        <VStack
            color={'neutral.100'}
            w={'100%'}>
            <Flex
                justifyContent={'space-between'}
                alignItems={'center'}
                p={{base: '16px 10px', md: '11px 0'}}
                w={'100%'}
            >
                <Heading color={'neutral.100'} fontSize={'heading.3xl'}>Notifications templates</Heading>
                <StyledButton
                    onClick={() => setActiveTab('addNotifications')}
                >Add</StyledButton>
            </Flex>
            <Box
                w={'full'}
                p={{base: '16px', md: '16px 32px'}}
                bg={'neutral.1100'}
                borderRadius={{base: '0', md: '16px'}}
                display={'flex'}
                flexDirection={'column'}
                gap={'16px'}
            >
                {currentItems.map((item) => (
                    <Box
                        key={item.id}
                        w={'full'}
                        display={'flex'}
                        flexWrap={'wrap'}
                        flexDirection={'column'}
                        gap={'24px'}
                        justifyContent={'space-between'}
                    >
                        <Flex
                            w={'full'}
                            flexDirection={'column'}
                            gap={'24px'}
                        >

                            <Flex
                                w={'full'}
                                gap={'1px'}
                                flexDirection={{base: 'column', md: 'row'}}
                            >
                                <VStack
                                    borderTopLeftRadius={{base: '0', md: '8px'}}
                                    borderBottomLeftRadius={{base: '0', md: '8px'}}
                                    p={'8px 16px 16px 16px'}
                                    bg={'neutral.1000'}
                                    gap={'24px'}>
                                    <Box
                                        w={'full'}
                                        display={'flex'}
                                        flexDirection={'row'}
                                        alignItems={'center'}
                                        p={'8px 12px'}
                                        justifyContent={'space-between'}
                                        borderBottom={'solid 1px #353945'}
                                    >
                                        <Heading fontSize={'18px'} textTransform={'capitalize'} >{item.name}</Heading>

                                        <Flex  gap={'8px'}>
                                            <StyledButton
                                                maxHeight={'32px'}
                                                border={'solid 1px #5834A8'}
                                                padding={'8px 6px'}
                                                bg={'transparent'}
                                                maxWidth={'32px'}><Delete/>
                                            </StyledButton>
                                            <StyledButton
                                                maxHeight={'32px'}
                                                border={'solid 1px #5834A8'}
                                                padding={'8px 6px'}
                                                bg={'transparent'}
                                                maxWidth={'32px'}
                                            ><Edit/></StyledButton>
                                        </Flex>
                                    </Box>
                                    <Box>
                                        <Box
                                            display={'flex'}
                                            flexWrap={'wrap'}
                                            gap={'8px'}
                                        >
                                            {item.tags.map((tag) => (
                                                <StyledButton
                                                    key={tag.id}
                                                    width={'max-content'}
                                                    maxHeight={'20px'}
                                                    bg={'#5834A8'}
                                                    fontWeight={'400'}
                                                    fontSize={'12px'}
                                                    fontSizeBase={'12px'}
                                                >{tag.title}</StyledButton>
                                            ))}
                                        </Box>
                                    </Box>
                                </VStack>
                            </Flex>
                        </Flex>
                    </Box>
                ))}
                <PaginationRow
                    pageCount={totalPages}
                    onPageChange={setCurrentPage}
                    itemsPerPage={itemsPerPage}
                    onItemsPerPageChange={(newCount) => {
                        setItemsPerPage(newCount);
                        setCurrentPage(0);
                    }}
                />
            </Box>
        </VStack>

    )
}
export default Notifications